export const assets = [
  {
    name: 'leo',
    symbol: 'leo',
    decimals: 6,
    image: 'https://ipfs.io/ipfs/bafybeifl7ay5rl2izaevluwenncyhfhoazqhrf5zeabeyfm5sknplwnmca',
    contractName: 'leo-token',
    contractAddress: 'SP1AY6K3PQV5MRT6R4S671NWW2FRVPKM0BR162CT6',
  },
  {
    name: 'bull',
    symbol: 'bull',
    decimals: 9,
    image: 'https://ipfs.io/ipfs/bafkreif46elvnl6n6jqb3fiftnzzprl5f4vlh34llv2rrlqh3hhvqupcha',
    contractName: 'bull',
    contractAddress: 'SP1Q4E6971M7HJ6H8XXDSCAFJ96GEQ02RNN8S55ZZ',
  },
  {
    name: 'ALL',
    symbol: 'ALL',
    decimals: 0,
    image: 'https://ipfs.io/ipfs/bafkreiabvmnoxnsiui23hcuypaifp5h6ntgrg46exzt3vxyb4pezq2br2y',
    contractName: 'ALL',
    contractAddress: 'SP351ZJK9F5AWZJEEZGZ7NZKSRKA65EWFRR48V9KS',
  },
  {
    name: 'zwstx',
    symbol: 'zwstx',
    decimals: 6,
    image: null,
    contractName: 'zwstx-v1',
    contractAddress: 'SP2VCQJGH7PHP2DJK7Z0V48AGBHQAW3R3ZW1QF4N',
  },
  {
    name: 'zststx',
    symbol: 'zststx',
    decimals: 6,
    image: null,
    contractName: 'zststx-v1-0',
    contractAddress: 'SP2VCQJGH7PHP2DJK7Z0V48AGBHQAW3R3ZW1QF4N',
  },
  {
    name: 'aeUSDC',
    symbol: 'aeUSDC',
    decimals: 6,
    image:
      'https://allbridge-assets.web.app/320px/ETH/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48.svg',
    contractName: 'token-aeusdc',
    contractAddress: 'SP3Y2ZSH8P7D50B0VBTSX11S7XSG24M1VB9YFQA4K',
  },
  {
    name: 'stSTX',
    symbol: 'ststx',
    decimals: 6,
    image: 'https://app.stackingdao.com/stackingdao-logo.png',
    contractName: 'ststx-token',
    contractAddress: 'SP4SZE494VC2YC5JYG7AYFQ44F5Q4PYV7DVMDPBG',
  },
  {
    name: 'LONG Token',
    symbol: 'LONG',
    decimals: 6,
    image:
      'https://images.ctfassets.net/frwmwlognk87/4gKhLHw09nsWjmPlufTjmT/d5432569911d82c3052755b77e0f64dc/LONGcoin-image-2.png',
    contractName: 'longcoin',
    contractAddress: 'SP265WBWD4NH7TVPYQTVD23X3607NNK4484DTXQZ3',
  },
  {
    name: 'ALEX Token',
    symbol: 'ALEX',
    decimals: 8,
    image:
      'https://assets.hiro.so/api/mainnet/token-metadata-api/SP102V8P0F7JX67ARQ77WEA3D3CFB5XW39REDT0AM.token-alex/1-thumb.png',
    contractName: 'age000-governance-token',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'Auto ALEX',
    symbol: 'auto-alex-v2',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/AutoALEXV2_Token.png',
    contractName: 'auto-alex-v2',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'Auto ALEX',
    symbol: 'auto-alex',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/AutoALEX_Token.png',
    contractName: 'auto-alex',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'ATMT (BRC20)',
    symbol: 'ATMT',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/ATMT_Token.png',
    contractName: 'brc20-aiptp',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'CHAX (BRC20)',
    symbol: 'CHAX',
    decimals: 0,
    image:
      'https://images.ctfassets.net/frwmwlognk87/G9masn8HHScnhhlFp5HaP/ca601a578cb6417960688f53f83cd470/logo.svg',
    contractName: 'brc20-chax',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'cvlt (BRC20)',
    symbol: 'cvlt',
    decimals: 8,
    image: null,
    contractName: 'brc20-cvlt',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: '$B20 (BRC20)',
    symbol: '$B20',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/B20_Token_round.png',
    contractName: 'brc20-db20',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'DEXM (BRC20)',
    symbol: 'DEXM',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/DEXM_Token.png',
    contractName: 'brc20-dexm',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'INSC (BRC20)',
    symbol: 'INSC',
    decimals: 8,
    image: null,
    contractName: 'brc20-insc',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'lbow (BRC20)',
    symbol: 'lbow',
    decimals: 8,
    image: null,
    contractName: 'brc20-lbow',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'LONG (BRC20)',
    symbol: 'LONG',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/BRC20_LONG_Token.png',
    contractName: 'brc20-long',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'MAJO (BRC20)',
    symbol: 'MAJO',
    decimals: 8,
    image: null,
    contractName: 'brc20-majo',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'MAXI (BRC20)',
    symbol: 'MAXI',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/BRC20_MAXI_Token.png',
    contractName: 'brc20-maxi',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'ordg (BRC20)',
    symbol: 'ordg',
    decimals: 8,
    image:
      'https://images.ctfassets.net/frwmwlognk87/4IHVeMevpesMr1i38sycfz/53c669810394151c67733e24f2fa5651/ORDG_icon_large.png',
    contractName: 'brc20-ordg',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'ornj (BRC20)',
    symbol: 'ornj',
    decimals: 0,
    image:
      'https://images.ctfassets.net/frwmwlognk87/3UZiZVSZpcFSYqw7csCkPb/9359ee6d914db78aff7cf06cbf5a35e1/Orange_Pill_Avatar_3D_Round.png',
    contractName: 'brc20-ornj',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'ormm (BRC20)',
    symbol: 'ormm',
    decimals: 0,
    image:
      'https://images.ctfassets.net/frwmwlognk87/2RqydiGw6WIAUaDnq2oSbt/82157b3831ef2ddf1e9c4bf060c49947/ORMM-2.png',
    contractName: 'brc20-ormm',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'oxbt (BRC20)',
    symbol: 'oxbt',
    decimals: 8,
    image: null,
    contractName: 'brc20-oxbt',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'PIZA (BRC20)',
    symbol: 'PIZA',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/BRC20_PIZA_Token.png',
    contractName: 'brc20-piza',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'sats (BRC20)',
    symbol: 'sats',
    decimals: 8,
    image: null,
    contractName: 'brc20-sats',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'SHNT (BRC20)',
    symbol: 'SHNT',
    decimals: 8,
    image: null,
    contractName: 'brc20-shnt',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'taro (BRC20)',
    symbol: 'taro',
    decimals: 8,
    image: null,
    contractName: 'brc20-taro',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'vmpx (BRC20)',
    symbol: 'vmpx',
    decimals: 8,
    image: null,
    contractName: 'brc20-vmpx',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'sLUNR',
    symbol: 'sLUNR',
    decimals: 8,
    image: null,
    contractName: 'token-slunr',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'sUSDT',
    symbol: 'sUSDT',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/sUSDT.png',
    contractName: 'token-susdt',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'Arkadiko Token',
    symbol: 'DIKO',
    decimals: 6,
    image: 'https://app.arkadiko.finance/assets/tokens/diko.svg',
    contractName: 'arkadiko-token',
    contractAddress: 'SP2C2YFP12AJZB4MABJBAJ55XECVS7E4PMMZ89YZR',
  },
  {
    name: 'Staked Arkadiko Token',
    symbol: 'stDIKO',
    decimals: 6,
    image: null,
    contractName: 'stdiko-token',
    contractAddress: 'SP2C2YFP12AJZB4MABJBAJ55XECVS7E4PMMZ89YZR',
  },
  {
    name: 'USDA',
    symbol: 'USDA',
    decimals: 6,
    image: 'https://app.arkadiko.finance/assets/tokens/usda.svg',
    contractName: 'usda-token',
    contractAddress: 'SP2C2YFP12AJZB4MABJBAJ55XECVS7E4PMMZ89YZR',
  },
  {
    name: 'Wrapped USD',
    symbol: 'xUSD',
    decimals: 8,
    image: 'https://wrapped.com/images/xusd.png',
    contractName: 'Wrapped-USD',
    contractAddress: 'SP2TZK01NKDC89J6TA56SA47SDF7RTHYEQ79AAB9A',
  },
  {
    name: 'ALEX Power Token',
    symbol: 'APower',
    decimals: 8,
    image: 'https://cdn.alexlab.co/logos/APower_Token.png',
    contractName: 'token-apower',
    contractAddress: 'SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9',
  },
  {
    name: 'Welshcorgicoin',
    symbol: 'WELSH',
    decimals: 6,
    image:
      'https://raw.githubusercontent.com/Welshcorgicoin/Welshcorgicoin/main/logos/welsh_tokenlogo.png',
    contractName: 'welshcorgicoin-token',
    contractAddress: 'SP3NE50GEXFG9SZGTT51P40X2CKYSZ5CC4ZTZ7A2G',
  },
  {
    name: 'Wrapped Bitcoin',
    symbol: 'xBTC',
    decimals: 8,
    image: 'https://wrapped.com/images/xbtc.png',
    contractName: 'Wrapped-Bitcoin',
    contractAddress: 'SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR',
  },
  {
    name: 'DOGE',
    symbol: 'doge',
    decimals: 0,
    image: 'https://ipfs.io/ipfs/bafkreidauyhja3xuvnfcrno33gqlh2krrnbvx7fks6ust5xr7wltxp6cie',
    contractName: 'doge',
    contractAddress: 'SP1Q4E6971M7HJ6H8XXDSCAFJ96GEQ02RNN8S55ZZ',
  },
  {
    name: 'ALEX Token',
    symbol: 'ALEX',
    decimals: 8,
    image:
      'https://assets.hiro.so/api/mainnet/token-metadata-api/SP102V8P0F7JX67ARQ77WEA3D3CFB5XW39REDT0AM.token-alex/1-thumb.png',
    contractName: 'token-alex',
    contractAddress: 'SP102V8P0F7JX67ARQ77WEA3D3CFB5XW39REDT0AM',
  },
  {
    name: '$WEN',
    symbol: 'WEN',
    decimals: 6,
    image:
      'https://assets.hiro.so/api/mainnet/token-metadata-api/SP25K3XPVBNWXPMYDXBPSZHGC8APW0Z21CWJ3Y3B1.wen-nakamoto-stxcity/1-thumb.png',
    contractName: 'wen-nakamoto-stxcity',
    contractAddress: 'SP25K3XPVBNWXPMYDXBPSZHGC8APW0Z21CWJ3Y3B1',
  },
];
